module.exports = __webpack_public_path__ + "img/saudiBusiness.cf64be99.png";